import { TASK_TARGET_FAIL, TASK_TARGET_PENDING, TASK_TARGET_SUCCESS } from "../../../actions/types";

const initialState = {
  tasksTarget: [],
  isTaskTargetLoading: false,
};

const tasks_target_reducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
      case TASK_TARGET_SUCCESS:
        return {
          ...state,
          tasksTarget: payload.tasksTarget,
          isTaskTargetLoading: false,
        };
      case TASK_TARGET_PENDING:
        return {
          ...state,
          tasksTarget: payload.tasksTarget,
          isTaskTargetLoading: true,
        };
      case TASK_TARGET_FAIL:
        return {
          ...state,
          tasksTarget: [],
          isTaskTargetLoading: false,
        };
        default:
      return state;
    }
}
export default tasks_target_reducer;